
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hotell",
      function () {
        return require("private-next-pages/hotell.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hotell"])
      });
    }
  